import { SaneImage } from '@components/sanity/sane-image';
import { PageProps } from '../../../types/page-props';
import { CtaCard } from '@components/common/cta-buttons';

const header = 'Multifactor Authentication';

const subheader = 'Add MFA to your application with the flip of a switch.';

export function Hero(props: PageProps) {
  const { image } = props;
  return (
    <div className="overflow-hidden">
      <main className="lg:relative">
        <div className="mx-auto w-full max-w-7xl pt-16 pb-20 text-center lg:py-48 lg:text-left">
          <div className="px-4 sm:px-8 lg:w-1/2 xl:pr-16">
            <h1 className="text-4xl font-extrabold tracking-tight text-gray-900 sm:text-5xl md:text-6xl lg:text-5xl xl:text-6xl">
              <span>{header}</span>
            </h1>
            <p className="mx-auto mt-3 max-w-md text-lg text-gray-500 sm:text-xl md:mt-5 md:max-w-3xl">
              {subheader}
            </p>
            <CtaCard title={props.seo.title} />
          </div>
        </div>
        <div className="relative hidden h-64 w-full items-center sm:h-72 md:h-96 lg:absolute lg:inset-y-0 lg:right-0 lg:flex lg:h-full lg:w-1/2">
          <SaneImage
            src={image.mfaform}
            alt="Social SSO illustration"
            className="mx-auto"
          />
        </div>
      </main>
    </div>
  );
}
